import { defineStyleConfig } from '@chakra-ui/system';

export const Form = defineStyleConfig({
    baseStyle: {
        helperText: {
            textStyle: 'slt-body-text',
            fontSize: '1rem',
            lineHeight: '1.375rem',
            color: 'slt-black.900',
            marginTop: 1,
        },
    },
    variants: {
        'new-style': {
            helperText: {
                textStyle: 'body-small',
                fontSize: '0.875rem',
                color: 'slt-pepper.1000',
                marginTop: 1,
            },
        },
    },
});
